import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import pt from './locales/pt.json';
import ar from './locales/ar.json';
import hi from './locales/hi.json';
import zh from './locales/zh.json';
import ja from './locales/ja.json';
import yo from './locales/yo.json';
import ha from './locales/ha.json';
import ig from './locales/ig.json';
import sw from './locales/sw.json';
import am from './locales/am.json';
import zu from './locales/zu.json';
import bn from './locales/bn.json';
import ta from './locales/ta.json';
import ko from './locales/ko.json';
import id from './locales/id.json';
import th from './locales/th.json';
import ur from './locales/ur.json';
import de from './locales/de.json';
import it from './locales/it.json';
import ru from './locales/ru.json';
import tr from './locales/tr.json';
import vi from './locales/vi.json';
import tl from './locales/tl.json';
import nl from './locales/nl.json';
import ms from './locales/ms.json';
import pl from './locales/pl.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      fr: { translation: fr },
      pt: { translation: pt },
      ar: { translation: ar },
      hi: { translation: hi },
      zh: { translation: zh },
      ja: { translation: ja },
      yo: { translation: yo },
      ha: { translation: ha },
      ig: { translation: ig },
      sw: { translation: sw },
      am: { translation: am },
      zu: { translation: zu },
      bn: { translation: bn },
      ta: { translation: ta },
      ko: { translation: ko },
      id: { translation: id },
      th: { translation: th },
      ur: { translation: ur },
      de: { translation: de },
      it: { translation: it },
      ru: { translation: ru },
      tr: { translation: tr },
      vi: { translation: vi },
      tl: { translation: tl },
      nl: { translation: nl },
      ms: { translation: ms },
      pl: { translation: pl }
    },
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

// Auto-detect language from user's geolocation on first visit
const GEO_DETECTED_KEY = 'subzero-geo-detected';
if (!localStorage.getItem(GEO_DETECTED_KEY) && !localStorage.getItem('i18nextLng')) {
  const API = process.env.REACT_APP_BACKEND_URL || '';
  fetch(`${API}/api/geo/detect-language`)
    .then(res => res.json())
    .then(data => {
      if (data.lang && data.lang !== 'en' && data.source === 'geo') {
        const supportedLangs = Object.keys(i18n.options.resources || {});
        if (supportedLangs.includes(data.lang)) {
          i18n.changeLanguage(data.lang);
        }
      }
      localStorage.setItem(GEO_DETECTED_KEY, 'true');
    })
    .catch(() => {
      localStorage.setItem(GEO_DETECTED_KEY, 'true');
    });
}

export const LANGUAGES = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'nl', name: 'Nederlands', flag: '🇳🇱' },
  { code: 'pl', name: 'Polski', flag: '🇵🇱' },
  { code: 'pt', name: 'Português', flag: '🇧🇷' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'tr', name: 'Türkçe', flag: '🇹🇷' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦', rtl: true },
  { code: 'ur', name: 'اردو', flag: '🇵🇰', rtl: true },
  { code: 'hi', name: 'हिन्दी', flag: '🇮🇳' },
  { code: 'bn', name: 'বাংলা', flag: '🇧🇩' },
  { code: 'ta', name: 'தமிழ்', flag: '🇮🇳' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
  { code: 'ja', name: '日本語', flag: '🇯🇵' },
  { code: 'ko', name: '한국어', flag: '🇰🇷' },
  { code: 'vi', name: 'Tiếng Việt', flag: '🇻🇳' },
  { code: 'tl', name: 'Filipino', flag: '🇵🇭' },
  { code: 'id', name: 'Bahasa Indonesia', flag: '🇮🇩' },
  { code: 'ms', name: 'Bahasa Melayu', flag: '🇲🇾' },
  { code: 'th', name: 'ไทย', flag: '🇹🇭' },
  { code: 'yo', name: 'Yorùbá', flag: '🇳🇬' },
  { code: 'ha', name: 'Hausa', flag: '🇳🇬' },
  { code: 'ig', name: 'Igbo', flag: '🇳🇬' },
  { code: 'sw', name: 'Kiswahili', flag: '🇰🇪' },
  { code: 'am', name: 'አማርኛ', flag: '🇪🇹' },
  { code: 'zu', name: 'isiZulu', flag: '🇿🇦' }
];

export default i18n;
